import { render, staticRenderFns } from "./DefaultHeaderDropdownAccntClient.vue?vue&type=template&id=f08bdac8"
import script from "./DefaultHeaderDropdownAccntClient.vue?vue&type=script&lang=js"
export * from "./DefaultHeaderDropdownAccntClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports